// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"7dd2d701","708":"61adaf79","787":"633816a4","875":"a6430c96"}[chunkId] + ".chunk.js";
};